const BranchCard = ({ selectedBranches, t, fromPDP = false }) => {
  if (fromPDP) {
    return (
      <div className={`border-border mb-4 rounded-lg border p-4 max-sm:p-2`}>
        <div className='flex items-start justify-between gap-3'>
          <div className='flex flex-col gap-1'>
            <div className='flex items-center gap-4'>
              <div className='max-w-44 text-sm font-bold'>
                {selectedBranches?.address}
              </div>

              {(selectedBranches?.source_region_name ||
                selectedBranches?.source_city_name) && (
                <div className='rounded-lg bg-gray-100 p-0.5 px-2 text-sm text-gray-700'>
                  {selectedBranches?.source_region_name} .{' '}
                  {selectedBranches?.source_city_name}
                </div>
              )}

              <div className='rounded-lg bg-[#ECFDF5] p-0.5 px-2 text-sm text-[#5DAC91]'>
                {selectedBranches?.name}
              </div>
            </div>

            <span className='text-sm'>
              <span className='text-gray-500'>{t('available_qty')}:</span>{' '}
              {selectedBranches?.qty || 0}
            </span>

            {selectedBranches?.distance && (
              <span className='text-sm text-gray-500'>
                {t('distance')}: {selectedBranches?.distance?.toFixed(2)}{' '}
                {t('km')}
              </span>
            )}
          </div>

          <a
            href={`https://maps.google.com/maps/dir/?api=1&destination=${selectedBranches?.lat},${selectedBranches?.lng}`}
            target='_blank'
            rel='noopener noreferrer'
            className='border-border w-fit rounded-lg border px-3 py-1.5 text-[11px] font-medium'
          >
            {t('open_map')}
          </a>
        </div>
      </div>
    );
  }

  return (
    <aside className='rounded-2xl bg-white p-4 shadow'>
      <div className='flex items-center justify-between'>
        <h2 className='font-bold'>{t('branches_list')}</h2>
        <span className='text-xs text-slate-500'>
          {Array.isArray(selectedBranches) ? selectedBranches.length : 0}{' '}
          {t('branch')}
        </span>
      </div>
      {Array.isArray(selectedBranches) && selectedBranches.length === 0 && (
        <p className='mt-2 text-slate-600'>{t('no_results')}</p>
      )}
      {/* Scrollable results matching the map height */}
      <div className='mt-2 max-h-[520px] divide-y overflow-y-auto'>
        {Array.isArray(selectedBranches) &&
          selectedBranches?.map((b) => (
            <div key={b?.id} className='py-3'>
              <div className='font-semibold'>
                {b?.code} — {b?.address}
              </div>
              <div className='text-sm'>
                {t('phone')}: {b?.phone}
              </div>
              <div className='text-xs text-gray-600'>{b?.open_time_hours}</div>
              <div className='mt-2 flex flex-wrap items-center gap-2'>
                {b?.distance && (
                  <span className='rounded-full bg-sky-50 px-2 py-1 text-[11px] text-sky-900'>
                    ≈ {b?.distance?.toFixed(2)} {t('km')}
                  </span>
                )}
                <a
                  className='rounded-lg bg-[#1e2b55] px-3 py-2 text-sm text-white'
                  href={`tel:${b.phone}`}
                >
                  📞 {t('call')}
                </a>
                <a
                  className='rounded-lg border border-[#1e2b55] bg-white px-3 py-2 text-sm text-[#1e2b55]'
                  href={`https://www.google.com/maps/dir/?api=1&destination=${b.lat},${b.lng}`}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  🗺️ {t('directions')}
                </a>
              </div>
            </div>
          ))}
      </div>
    </aside>
  );
};

export default BranchCard;
